import React from 'react';
import { styles } from './MovieRating.css';

export type MovieRatingProps = {
  description: string;
  icon: string;
  consumerAdvice?: string;
  isReleaseDateInPast?: boolean;
  releaseDateFormatted?: string;
};

export const MovieRating = ({
  description,
  icon,
  consumerAdvice,
  isReleaseDateInPast,
  releaseDateFormatted,
}: MovieRatingProps) => {
  return (
    <>
      <div className={styles.movieRatingContainer}>
        <div className={styles.movieRatingIconWrap}>
          <img alt="Movie rating icon" className={styles.icon} src={icon} />
        </div>
        <div className={styles.movieRatingText}>
          <span className={styles.description}>{description}</span>
          {consumerAdvice ? <span className={styles.consumerAdvice}>Note: {consumerAdvice}</span> : null}
        </div>
      </div>
      {isReleaseDateInPast ? (
        <div className={styles.releaseDateContainer}>
          <span className={styles.releaseDateTitle}>Release date: </span>
          <span className={styles.releaseDate}>{releaseDateFormatted}</span>
        </div>
      ) : null}
    </>
  );
};
